/*
 * @Author: Liux
 * @Date: 2019-12-03 07:28:49
 * @LastEditor: Liux
 * @LastEditTime: 2022-01-20 17:32:33
 */
import {
  Component,
  OnInit,
  Inject,
  TemplateRef,
  ViewEncapsulation,
  ViewChild,
} from '@angular/core';
import { AdDateRangeEventService } from '../services/ad-date-range-event.service';
import { CONFIG_DATA } from '../common/ad-date-range-inject-key';
import { AdDateRangeModel } from '../common/ad-date-range-model';
import {
  CalendarMonthViewDay,
  CalendarMonthViewComponent,
  CalendarView,
} from 'angular-calendar';
import { ViewPeriod } from 'calendar-utils';
import {
  eachDayOfInterval,
  format,
  addDays,
  addMonths,
  addYears,
  setMonth,
  setYear,
  isWithinInterval,
} from 'date-fns';
import { AdDateRangeComponent } from '../ad-date-range.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ad-date-range-popup',
  templateUrl: './ad-date-range-popup.component.html',
  styleUrls: ['./ad-date-range-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('showAndHidePopup', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scaleY(0.8)' }),
        animate('.12s cubic-bezier(0, 0, 0.2, 1)'),
      ]),
      transition(':leave', [
        animate('.1s linear', style({ opacity: 0 })),
      ]),
    ]),
  ],
  host: {
    '[@showAndHidePopup]': '',
  },
})
export class AdDateRangePopupComponent implements OnInit {
  showMonthPopup = false;
  showYearPopup = false;
  rangeValueSubscripter?: Subscription;
  constructor(
    private eventService: AdDateRangeEventService,
    @Inject(CONFIG_DATA) private componentData: any
  ) {
    this.dateRangeComponent = this.componentData.component;
    this.context.component = this.dateRangeComponent;
    if (componentData && componentData.rangeValue) {
      this.viewDate =
        componentData.rangeValue.startDate ||
        componentData.rangeValue.endDate ||
        new Date();
    } else {
      this.viewDate = new Date();
    }
  }

  @ViewChild('calendar', { static: true })
  calendar: CalendarMonthViewComponent;
  view: CalendarView = CalendarView.Month;
  _viewDate: Date;
  get viewDate() {
    return this._viewDate;
  }

  set viewDate(val: Date) {
    this._viewDate = val;
    setTimeout(() => {
      this.eventService.updatePosition.emit("")
    }, 10)
  }
  dateRangeComponent: AdDateRangeComponent;

  startDate: Date = null;
  endDate: Date = null;
  oldStartDate: Date = null;
  oldEndDate: Date = null;

  headerToolTemplate: TemplateRef<any>;
  footerToolTemplate: TemplateRef<any>;
  context = {
    click: (event, type: string) => {
      this.toolClickHandler(event, type);
    },
    close: (event) => {
      this.eventService.close.emit(event);
    },
    setRange: (event: AdDateRangeModel, autoApply: boolean = true) => {
      this.setRangeValue(event, autoApply);
    },
    setRangeByNumber: (
      anchorDate: Date,
      type: 'day' | 'month' | 'year',
      value: number,
      autoApply: boolean = true
    ) => {
      this.setRangeValueByNumber(anchorDate, type, value, autoApply);
    },
    reset: (event) => {
      this.resetValue();
    },
    restore: (event) => {
      this.restoreRangeValue();
    },
    apply: () => {
      this.emitRangeChange();
    },
    component: null,
  };
  monthSelect(month: number) {
    this.viewDate = setMonth(this.viewDate, month - 1);
    this.showMonthPopup = false;
  }
  yearSelect(year: number) {
    this.viewDate = setYear(this.viewDate, year);
    this.showYearPopup = false;
    this.showMonthPopup = true;
  }

  closeYearMonthPopup() {
    this.showMonthPopup = false;
    this.showYearPopup = false;
  }

  /**
   * Emit the range value change event.
   */
  emitRangeChange() {
    this.eventService.rangeValueChange.emit({
      oldStartDate: this.oldStartDate,
      oldEndDate: this.oldEndDate,
      startDate: this.startDate,
      endDate: this.endDate,
      days: []
      //days: this.getSelectedDays(),
    });
  }

  /**
   * Clear the range value.
   */
  resetValue() {
    this.setRangeValue({ startDate: null, endDate: null });
  }

  /**
   * Use the startDate and endDate in the componentData to restore the current selected date range, and emit the range value change event
   */
  restoreRangeValue() {
    if (this.componentData.rangeValue) {
      const startDate = this.componentData.rangeValue.startDate;
      const endDate = this.componentData.rangeValue.endDate;
      this.setRangeValue({ startDate, endDate });
    }
  }

  /**
   * Use a specific date range to modify the current date range, and emit the range value change event
   * @param event data range model
   */
  setRangeValue(event: AdDateRangeModel, autoApply: boolean = true) {
    this.oldStartDate = this.startDate;
    this.oldEndDate = this.endDate;
    this.startDate = event.startDate;
    this.endDate = event.endDate;
    this.viewDate = this.startDate || this.endDate || new Date();
    this.closeYearMonthPopup();
    setTimeout(() => {
      this.clearAllSelectedStyle();
      this.applySelectedStyle();

      if (autoApply) {
        this.emitRangeChange();
      }
    });
  }

  /**
   * Set a range value by the parameters.
   * @param anchorDate The anchor date is a seed, according to it's value to add or subtract a specific value to generate a date range.
   * @param type This type value accepts the following values--'month','day','year' to determine the value parameter is what type's value.
   * @param value To determine how much value to add or subtract.
   */
  setRangeValueByNumber(
    anchorDate: Date,
    type: 'day' | 'month' | 'year',
    value: number,
    autoApply: boolean = true
  ) {
    let fun;
    if (type === 'day') {
      fun = addDays;
    } else if (type === 'month') {
      fun = addMonths;
    } else if (type === 'year') {
      fun = addYears;
    }

    const result = fun(anchorDate, value);
    const startDate = value > 0 ? anchorDate : result;
    const endDate = value > 0 ? result : anchorDate;

    this.setRangeValue({ startDate, endDate }, autoApply);
  }

  toolClickHandler(event, type: string) {
    this.eventService.toolClick.emit({ event, type });
  }

  formatDate(date: Date) {
    return format(date, this.componentData.format);
  }

  ngOnInit() {
    this.headerToolTemplate = this.componentData.headerToolTemplate;
    this.footerToolTemplate = this.componentData.footerToolTemplate;

    if (this.componentData.rangeValue) {
      this.startDate = this.componentData.rangeValue.startDate;
      this.endDate = this.componentData.rangeValue.endDate;
    }
  }
  dayClick(event: CalendarMonthViewDay) {
    this.eventService.dateClick.emit(event);
    const date = event.date;
    const actionName = this.getActionName(date);

    if (actionName === 'start') {
      this.oldStartDate = this.startDate;
      this.startDate = date;
      event.cssClass = 'cal-day-selected cal-day-inrange';
    } else if (actionName === 'startAndClear') {
      this.clearAllSelectedStyle();
      this.oldStartDate = this.startDate;
      this.startDate = date;
      event.cssClass = 'cal-day-selected cal-day-inrange';
    } else if (actionName === 'end') {
      this.oldEndDate = this.endDate || this.componentData.rangeValue.endDate;
      this.endDate = date;
      this.applySelectedStyle();
      if (this.componentData.autoApplyDateRange) {
        this.emitRangeChange();
      }
    } else if (actionName === 'clear') {
      this.oldEndDate = this.endDate;
      this.endDate = null;
      this.oldStartDate = this.startDate;
      this.startDate = date;
      this.clearAllSelectedStyle();
      event.cssClass = 'cal-day-selected cal-day-inrange';
    }

    this.eventService.dateRangeClick.emit({
      oldStartDate: this.oldStartDate,
      oldEndDate: this.oldEndDate,
      startDate: this.startDate,
      endDate: this.endDate,
      actionName,
    });
  }

  clearAllSelectedStyle() {
    this.calendar.view.days.forEach((day) => {
      delete day.cssClass;
    });
  }

  applySelectedStyle() {
    //const selectedDays = this.getSelectedDays(true);
    this.calendar.view.days.forEach((day) => {
      const formatDay = this.formatDate(day.date);
      if (
        (this.startDate && formatDay === this.formatDate(this.startDate)) ||
        (this.endDate && formatDay === this.formatDate(this.endDate))
      ) {
        if (
          this.startDate &&
          this.endDate &&
          this.formatDate(this.startDate) === this.formatDate(this.endDate)
        ) {
          // In a case that is the start and end is the same day.
          day.cssClass =
            'cal-day-selected cal-day-inrange cal-day-start cal-day-end';
        } else if (
          this.startDate &&
          formatDay === this.formatDate(this.startDate)
        ) {
          day.cssClass = 'cal-day-selected cal-day-inrange cal-day-start';
        } else {
          day.cssClass = 'cal-day-selected cal-day-inrange cal-day-end';
        }
      } else {
        if (this.startDate === null && this.endDate === null) {
          return;
        }
        if (isWithinInterval(day.date, { start: this.startDate || this.endDate, end: this.endDate || this.startDate })) {
          day.cssClass = 'cal-day-inrange';
        }
        // if (
        //   selectedDays.some(
        //     (selectedDay) => selectedDay === this.formatDate(day.date)
        //   )
        // ) {

        // }
      }
    });
  }

  getActionName(date) {
    if (this.startDate === null) {
      if (this.endDate === null) {
        return 'start';
      } else {
        return 'clear';
      }
    } else if (this.endDate === null) {
      if (this.startDate) {
        if (date < this.startDate) {
          return 'startAndClear';
        } else {
          return 'end';
        }
      } else {
        return 'start';
      }
    } else {
      return 'clear';
    }
  }

  getSelectedDays(isFormat: boolean = false): any[] {
    let selectedDays = [];
    if (this.startDate) {
      if (this.endDate) {
        selectedDays = eachDayOfInterval({
          start: this.startDate,
          end: this.endDate,
        });
      } else {
        selectedDays = [this.startDate];
      }
    } else {
      if (this.endDate) {
        selectedDays = [this.endDate];
      }
    }
    if (isFormat) {
      selectedDays = selectedDays.map((item) => this.formatDate(item));
    }

    return selectedDays;
  }

  beforeMonthViewRender({
    body,
    period,
  }: {
    body: CalendarMonthViewDay[];
    period: ViewPeriod;
  }): void {
    // const selectedDays = this.getSelectedDays(true);
    // if (selectedDays.length > 0) {
    //   this.applySelectedStyle();
    // }

    if (this.startDate || this.endDate) {
      this.applySelectedStyle();
    }
  }

  viewDateChange(event) {
    this.viewDate = event;
  }
}
